import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { DesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';
import { TranslateService } from '@ngx-translate/core';

const displayControlTemplate = `<div style="max-width:800px"><img class="map-image" style="max-width:800px" src="https://files.topo.ai/images/email/sample-map.png" /></div>`;
const settingsControlTemplate = ``;

export class MapControl extends DesignControl {
  public canEdit = false;
  public canCopy = false;
  public canDelete = true;

  constructor(document: Document, templateControlService: TemplateControlService, translateService: TranslateService) {
    super(document, templateControlService);

    this.controlTemplate = displayControlTemplate;
    this.settingsTemplate = settingsControlTemplate;
    this.controlType = TemplateControlType.Map;
  }

  public edit(): void {}

  public cancel(): void {}

  public save(): void {}

  public copy(): void {}
}
